// extracted by mini-css-extract-plugin
export default {"commentsInput":"CommentsInput_commentsInput__irEi7"};